<template>
    <div class="social-network d-flex justify-content-between ms-sm-4">
        <a target="_blank"
           v-for="(link, index) in links"
           :href="link.url"
           :aria-label="link.title"
           :class="getCssClassByLinkUrl(link.url)"
           :key="'Social_link_' + index">
        </a>
    </div>
</template>

<script>
    export default {
        name: 'social-network',

        props: {
            links: {
                type: Array
            }
        },

        methods: {
            getCssClassByLinkUrl(link) {
                if (link.includes('linkedin'))
                    return 'linkedin';

                if (link.includes('facebook'))
                    return 'facebook';

                if (link.includes('twitter'))
                    return 'twitter';

                if (link.includes('instagram'))
                    return 'instagram';

                return '';
            }
        }
    }
</script>